import { motion } from "framer-motion";
import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../components/Footer/Footer";
import PageTop from "../components/PageTop/PageTop";
import Spacer from "../components/Utils/Spacer";
import { Context } from "../context";

const Cookie = () => {
  const { debug, lang } = useContext(Context);

  return (
    <>
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4 }}
      >
        <title>Cookie - davidebalice.dev</title>
        <PageTop pageTitle="" />

        <Container className="text-justify privacy-page">
          <Row>
            <Col>
              <Spacer height={60} />

              {lang === "en" && (
                <>
                  <h2>Cookie policy of www.davidebalice.dev</h2>

                  <p>
                    The term Application refers to this same website
                    www.davidebalice.dev and all the demos connected to it
                    published on third-level domains with the extension
                    demo-name.davidebalice.dev.
                  </p>

                  <br />

                  <p>
                    <h2>Cookie</h2>
                    Cookies are tracking tools that consist of small portions of
                    data stored within the browser of the User.
                    <br />
                    This document contains information regarding the use of
                    Cookies by this Application.
                  </p>

                  <br />

                  <p>
                    <h2>Technical cookies</h2>
                    This Application uses Cookies commonly called "technical" to
                    carry out activities strictly necessary to guarantee the
                    functioning and provision of the Service or of the demos
                    connected to it.
                    <br />
                    The "technical" Cookies always sent by this Application or
                    by the demos with the extension name-demo.davidebalice.dev,
                    are necessary to correctly display the pages and in relation
                    to the technical services offered, they will therefore
                    always be used and sent, unless the user changes the
                    settings in their browser (thus affecting the display of the
                    pages themselves or their functionality).
                  </p>

                  <br />

                  <p>
                    <h2>Third-party cookies or other tracking tools</h2>
                    This Application does not use any Cookies or third-party
                    tracking tools, no data on the User's behavior is saved and
                    transferred to third parties.
                    <br />
                    No traffic analysis systems are used.
                  </p>

                  <br />

                  <p>
                    <h2>Profiling cookies</h2>
                    Profiling Cookies are those cookies necessary to create user
                    profiles in order to send advertising messages in line with
                    the preferences expressed by the user within the pages of
                    the Site.
                    <br />
                    Profiling Cookies are not used by this Application.
                  </p>

                  <br />
                  <br />
                  <br />
                  <br />
                </>
              )}
              {lang === "it" && (
                <>
                  <h2>Cookie policy di www.davidebalice.dev</h2>

                  <p>
                    Con il termine Applicazione si intende questo stesso sitoweb
                    www.davidebalice.dev e tutte le demo ad esso collegate
                    pubblicate su domini di terzo livello con estensione
                    nome-demo.davidebalice.dev.
                  </p>

                  <br />

                  <p>
                    <h2>Cookie</h2>
                    I Cookie sono strumenti di tracciamento che consistono in
                    piccole porzioni di dati conservate all'interno del browser
                    dell'Utente.
                    <br />
                    Questo documento contiene informazioni in merito
                    all'utilizzo dei Cookie di questa Applicazione.
                  </p>

                  <br />

                  <p>
                    <h2>Cookie tecnici</h2>
                    Questa Applicazione utilizza Cookie comunemente detti
                    “tecnici” per svolgere attività strettamente necessarie a
                    garantire il funzionamento e la fornitura del Servizio o
                    delle demo ad esso collegate.
                    <br />I Cookie “tecnici” inviati sempre da questa
                    Applicazione o dalle demo con estensione
                    nome-demo.davidebalice.dev, sono necessari a visualizzare
                    correttamente le pagine e in relazione ai servizi tecnici
                    offerti, verranno quindi sempre utilizzati e inviati, a meno
                    che l’utenza non modifichi le impostazioni nel proprio
                    browser (inficiando così la visualizzazione delle pagine
                    stesse o le sue funzionalità).
                  </p>

                  <br />

                  <p>
                    <h2>
                      Cookie terze parti o altri strumenti di tracciamento
                    </h2>
                    Questa Applicazione non utilizza alcun Cookie o strumento di
                    tracciamento di terze parti, nessun dato sul comportamento
                    dell'Utente viene salvato e ceduto a terzi.
                    <br />
                    Non si utilizzano sistemi di analisi del traffico.
                  </p>

                  <br />

                  <p>
                    <h2>Cookie di profilazione</h2>
                    I Cookie di profilazione sono quei cookie necessari a creare
                    profili utenti al fine di inviare messaggi pubblicitari in
                    linea con le preferenze manifestate dall’utente all’interno
                    delle pagine del Sito.
                    <br />I Cookie di profilazione non vengono utilizzati da
                    questa Applicazione.
                  </p>

                  <br />
                  <br />
                  <br />
                  <br />
                </>
              )}
            </Col>
          </Row>
        </Container>

        <Footer />
      </motion.main>
    </>
  );
};

export default Cookie;
